export { default } from "ember-keyboard/modifiers/on-key";
